import { PropsWithChildren } from 'react';

import { EditorInner } from '@/components/TextEditor/TextEditor.utils';

export function CustomSlideTextEditorInner({ children }: PropsWithChildren) {
  return (
    <EditorInner borderRadius={0} sx={{ background: 'transparent' }}>
      {children}
    </EditorInner>
  );
}
